const Winners = () => import('./Main')

const route = {
  // path: '/winners',
  path: '/winners',
  name: 'winners',
  meta: {
    title: 'Winners - A D M A N 2 0 1 9'
  },
  component: Winners
}

export default route
